<template>
    <ProfileOptionSelector :model="'station'" :nextRoute="() => 'SmokingPage'" />
</template>

<script>
export default {
    name: 'StationPage',
    mounted() {
        this.$nativeBridge.postMessage({
            action: 'sendFirebaseEvent',
            value: {
                category: 'StationPage_Enter_StationPage',
                option: {
                    provider: this.$store.getters.payloads.signupData.provider || 'email',
                },
            },
        })
    },
}
</script>
